import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

/**
 * Functions as a sort of pseudo-router-outlet which serves the appropriate page
 * content based on the current {@link ents.core.admin.Page.Id}
 */
@ngCore.Component({
  imports: [
    content.dms.pages.catalog.Page,
    content.dms.pages.dimension.Page,
    content.dms.pages.enum_.Component,
    content.dms.pages.graph.Component,
    content.dms.pages.model.Component,
    content.dolomite.pages.chat.Component,
    content.dolomiteGeneral.pages.chat.Component,
    content.mosaic.dev.actions.Page,
    content.mosaic.dev.pages.Component,
    content.mosaic.dev.pages.builder.Component,
    content.mosaic.dev.widgets.Component,
    content.mosaic.dev.widgets.builder.Component,
    content.mosaic.rendering.page.Component,
    content.quiver.pages.deploymentCenter.Component,
    content.rate.pages.gl.Component,
    content.rate.pages.reportDetails.Component,
    content.rate.pages.reportList.Component,
    content.rate.pages.rules.Component,
    content.space.full.pages.clusterDetails.Component,
    content.space.full.pages.clusters.Component,
    content.space.full.pages.organizations.Component,
    content.space.full.pages.recordDetails.Component,
    content.space.full.pages.recordsList.Component,
    content.space.full.pages.reportDetails.Component,
    content.space.full.pages.reports.Component,
    content.space.full.pages.serviceCenters.Component,
    content.space.full.pages.surveyConfiguration.Component,
    content.space.full.pages.userAccess.Component,
    content.space.lite.pages.recordDetails.Component,
    content.space.lite.pages.recordsList.Component,
    content.space.lite.pages.surveyConfiguration.Component,
    content.space.lite.pages.userAccess.Component,
    content.stm.pages.chat.Component,
    content.summit.pages.allocation.Component,
    content.summit.pages.archive.Component,
    content.summit.pages.checkIns.Component,
    content.summit.pages.organization.Component,
    content.summit.pages.pulse.Component,
  ],
  selector: 'atn-app-page-content',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * Exposes {@link ents.extra.prebuilt.Page.Id} to the
   */
  public readonly PrebuiltPageId = ents.extra.prebuilt.Page.Id

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)
  /** @see {@link state.navigation.Feature} */
  private readonly _navigationFeature = ngCore.inject(state.navigation.Feature)
  /** Angular injector used when scheduling render callbacks from effects. */
  private readonly _injector = ngCore.inject(ngCore.Injector)

  /**
   * ID of the {@link ents.core.admin.Page} associated with the current
   * {@link ents.core.admin.App.Page}
   */
  public readonly pageIdSg = this._meFeature.contexts.selectors.pageId.asSignal

  /**
   * Reports when the selected pseudo-route page has been rendered.
   */
  private readonly _pageRenderedEffect = ngCore.effect(() => {
    const pageId = this.pageIdSg()

    if (!pageId) {
      return
    }

    ngCore.afterNextRender(
      () => {
        this._navigationFeature.actions.pageRendered
          .from(`AppPageContent.Rendered.${pageId}`)
          .dispatch()
      },
      { injector: this._injector },
    )
  })
}
